import { render } from "./MkPizza.vue?vue&type=template&id=4f4e5d59&scoped=true"
import script from "./MkPizza.vue?vue&type=script&lang=js"
export * from "./MkPizza.vue?vue&type=script&lang=js"

import "./MkPizza.vue?vue&type=style&index=0&id=4f4e5d59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4e5d59"]])

export default __exports__